var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"header1"},[_c('span',{staticClass:"img-container"},[_c('img',{staticClass:"img",attrs:{"src":require("../assets/JG-logo.png")}})])])])
}]

export { render, staticRenderFns }